// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__RZfS7","footer":"ModalError_footer__uEvw6"};